<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";
import DropdownComponent from "./components/resources/DropdownComponent.vue";
import GoogleSliderComponent from "./components/resources/GoogleSliderComponent.vue";
export default {
  name: "HomeView",
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
    /* eslint-disable*/
    DropdownComponent,
    /* eslint-disable*/
    GoogleSliderComponent,
  },
  data() {
    return {
      site: 29,
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>

<template> 
  <!-- SECCION MISION, VISION y VALOR -->
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-4 pe-4 pt-4">
          <h3 class="pb-3">Nuestra Misión</h3>
          <p>
            La misión de la DRHyOEP es diseñar e implementar Políticas Públicas
            para gestionar el Capital y el Talento Humano, fortalecer la
            Administración Pública Provincial y brindar soluciones eficientes y
            transparentes en pos de la mejora continua de la calidad del
            servicio público, procurando el desarrollo integral del empleado
            público y su valorización.
          </p>
        </div>
        <div class="col-12 col-sm-4 pe-4 pt-4">
          <h3 class="pb-3">Visión</h3>
          <p>
            Una DRHyOEP reconocida por contribuir al alcance de los objetivos
            del Estado Provincial, que brinda servicios y promueve una
            comunicación armónica y el trabajo colaborativo, respetuoso,
            honesto, responsable y eficiente para el desarrollo de las
            capacidades y el bienestar de todas las personas que integran la
            Administración Pública de la Provincia de San Juan.
          </p>
        </div>
        <div class="col-12 col-sm-4 pe-4 pt-4">
          <h3 class="pb-3">Valores</h3>
          <ul>
            <li>Respeto por el otro.</li>
            <li>Honestidad en el trabajo.</li>
            <li>Vocación de Servicio Público.</li>
            <li>Responsabilidad con los recursos asignados.</li>
            <li>Apertura al cambio, al aprendizaje y al trabajo en equipo.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- FIN SECCION MISION, VISION y VALOR -->

  <BoxIconGridComponent class="p-0 pb-5" columnas="6" :data="[
    // {
    //   desc: null,
    //   icon: 'auto_stories',
    //   target: '_blank',
    //   title: 'Capacitación',
    //   url: 'https://web.sanjuan.gob.ar/capacitacion/',
    // },
    {
      desc: null,
      icon: 'group',
      target: '_blank',
      title: 'USP',
      url: 'https://sites.google.com/view/encargadosyauxialiresdeusp/p%C3%A1gina-principal',
    },
    {
      desc: null,
      icon: 'groups',
      target: '_self',
      title: 'Info Agentes',
      url: 'https://sites.google.com/view/info-agentes/p%C3%A1gina-principal',
    },
    {
      desc: null,
      icon: 'psychology',
      target: '_blank',
      title: 'Capacitación',
      url: 'https://sites.google.com/view/capa2024/inicio',
    },
    {
      icon: 'diversity_3',
      target: '_blank',
      title: 'Sindicatos y Gremios',
      url: 'https://sites.google.com/view/gremios-y-sindicatos?usp=sharing',
    },
    {
      icon: 'find_in_page',
      target: '_blank',
      title: 'Consulta Normativa',
      url: 'https://digesto.sanjuan.gob.ar/digesto/',
    },
    {
      desc: null,
      icon: 'dvr',
      target: '_blank',
      title: 'SIARH',
      url: 'https://sites.google.com/view/siarh?usp=sharing',
    },
    /*
    {        icon: 'accessibility_new',

      target: '_self',
      title: 'ART e Higiene y Seguridad',
      url: '',
    },
    {        icon: 'accessibility_new',

      target: '_self',
      title: 'Registro Central de Personal',
      url: '',
    },
    {        icon: 'accessibility_new',

      target: '_self',
      title: 'Análisis de Estructura',
      url: '',
    },
    {        icon: 'accessibility_new',

      target: '_self',
      title: 'Ingresos y Promociones',
      url: '',
    }, 
    {        icon: 'accessibility_new',

      target: '_self',
      title: 'Violencia Laboral',
      url: '',
    },
 
    {        icon: 'accessibility_new',

      target: '_self',
      title: 'Firma Digital',
      url: '',
    },
    */
  ]" />
  <GoogleSliderComponent />

  <ITCGridComponent class="p-0 pb-5" titulo="Accesos de interés" :data="[
    {
      desc: null,
      icon: 'prescriptions',
      target: '_blank',
      title: 'Solicitud de Carta Médica (Junta Médica)',
      url: 'https://gedoc.sanjuan.gov.ar/dcrm/',
    },
    {
      desc: null,
      icon: 'post_add',
      target: '_blank',
      title: 'Afiliaciones (Obra Social Provincia)',
      url: 'http://www.obrasocial.sanjuan.gob.ar/dos/',
    },
    {
      desc: null,
      icon: 'assignment_turned_in',
      target: '_blank',
      title: 'Turnos Certificación de Títulos (M. Educación)',
      url: 'https://turnos.sanjuan.gob.ar',
    },
  ]" />

  <MultiSliderComponent titulo="" :elementos="2" :mostrar-titulo="true" :mostrar-bordes="true" :ajustar="true" :data="[
    {
      desc: null,
      imagen: require('@/assets/img/logo-firma-digital.jpg'),
      target: '_self',
      url: 'https://sites.google.com/view/firmadigitalsanjuan/p%C3%A1gina-principal',
    },
    {
      desc: null,
      imagen: require('@/assets/img/logo-higiene-seguridad.jpg'),
      target: '_self',
      url: '?uid=CUMV-accidente-profesional',
    },
    {
      desc: null,
      imagen: require('@/assets/img/logo-violencia-laboral.jpg'),
      target: '_blank',
      url: 'https://sites.google.com/view/abordaje-de-la-violencia-en-el/abordaje-de-la-violencia-en-el-%C3%A1mbito-laboral ',
    },
    {
      desc: null,
      imagen: require('@/assets/img/logo-certificado-activo.jpg'),
      target: '_blank',
      url: 'https://sites.google.com/view/consultacertificadodeactivos/consulta-de-activos',
    },
    {
      desc: null,
      imagen: require('@/assets/img/logo-estructura-organizacional.jpg'),
      target: '_blank',
      url: 'https://sites.google.com/view/analisisestructura?usp=sharing',
    },
  ]" />

  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <DocumentListComponent resultados="5" :show-fecha="false" titulo="Trámites Frecuentes" :data="[
          {
            title: 'Reconocimiento de Años de Servicio',
            target: '_blank',
            url: 'https://tramite.sanjuan.gob.ar/tramite/d/425/reconocimiento-de-anos-de-servicio',
          },
          {
            title: 'Firma Digital',
            target: '_blank',
            url: 'https://sites.google.com/view/firmadigitalsanjuan/p%C3%A1gina-principal',
          },
        ]" />
      </div>
      <div class="col-md-6">
        <DocumentListComponent resultados="5" :show-fecha="false" titulo="Preguntas Frecuentes" :data="[
          {
            title: '¿Cómo actuar en caso de accidente?',
            target: '_self',
            url: '?uid=CUMV-accidente-profesional',
          },
          {
            title: 'Teléfonos de contacto de la dirección',
            target: '_blank',
            url: 'https://sites.google.com/view/telefonos-drhyoep?usp=sharing',
          },
        ]" />
      </div>
    </div>
  </div>
  <!-- Componente noticias -->
  <NewsComponent titulo="Noticias" />

  <ITCGridComponent :columnas="3" titulo="Consultas y Trámites" :data="[
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Consulta de expedientes',
      url: '?uid=CUMV-VIEW-ExpedientesComponent',
    },
    {
      desc: null,
      icon: 'question_answer',
      target: '_self',
      title: 'Consultas y solicitudes',
      url: '?uid=CUMV-VIEW-FormComponent',
    },
    {
      desc: null,
      icon: 'ptn-i-acuerdo',
      target: '_self',
      title: 'Contrataciones',
      url: 'https://compraspublicas.sanjuan.gob.ar/',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Trámites',
      url: 'https://tramite.sanjuan.gob.ar/principal/listar',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Resultados de exámenes',
      url: 'https://hacienda.sanjuan.gob.ar/?uid=CUMV-VIEW-DocumentListComponent',
    },
  ]" />

  <FrecuentAccessComponent :data="[
    {
      title: 'Contacto',
      links: [
        {
          target: '_blank',
          title: '4305668- 4305660',
          url: 'tel:4305668',
        },
        {
          target: '_blank',
          title: 'Ubicación Centro Cívico, 2º piso, núcleo 5 y 6',
          url: 'https://goo.gl/maps/7VWTZNfmhBHUdrrP6',
        },
      ],
    },
  ]" />

  <GridLinkComponent :columnas="4" titulo="Links Útiles" :data="[
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Ministerio de Economía, Hacienda y Finanzas',
      url: 'https://hacienda.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Secretaria de la Transformación Digital y Modernización del Estado',
      url: 'https://sgp.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Dirección de Gobierno Digital',
      url: 'https://dga.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Ciudadano Digital',
      url: 'https://cidi.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Dirección de Ciberseguridad',
      url: 'https://ciberseguridad.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'IIEE - Instituto de Investigaciones Económicas y Estadísticas',
      url: 'https://web.sanjuan.gob.ar/iiee/',
    },
    {
      subtitle: 'Página Web',
      target: '_blank',
      title: 'Dirección Provincial de Informática',
      url: 'https://dpi.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Innova',
      url: 'http://sj.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Compras Públicas',
      url: 'https://compraspublicas.sanjuan.gob.ar/',
    },
  ]" />
</template>
